"use strict";

exports.__esModule = true;
exports.default = void 0;
var _constant = require("../_utils/constant");
var _common = require("../common");
function inputCreateAndAppend(multiple, accept) {
  var inputElement = document.createElement('INPUT');
  inputElement.name = 'file';
  inputElement.id = "input-" + Math.random() * 1e8;
  inputElement.type = 'file';
  multiple && inputElement.setAttribute('multiple', 'multiple');
  inputElement.style.display = 'none';
  accept && inputElement.setAttribute('accept', accept);
  document.body.appendChild(inputElement);
  return inputElement;
}
var chooseMedia = _common.normalize.chooseMedia(function (args) {
  if (args === void 0) {
    args = {};
  }
  var _args = args,
    _args$count = _args.count,
    count = _args$count === void 0 ? 9 : _args$count,
    _args$success = _args.success,
    success = _args$success === void 0 ? function () {} : _args$success,
    _args$fail = _args.fail,
    fail = _args$fail === void 0 ? function () {} : _args$fail,
    _args$complete = _args.complete,
    complete = _args$complete === void 0 ? function () {} : _args$complete;
  try {
    var inputElement = inputCreateAndAppend(count > 1, args.accept);
    var files = [];
    inputElement.addEventListener('change', function (e) {
      files = e.target.files && Array.from(e.target.files).slice(0, count);
      var res = {
        tempFiles: files.map(function (file) {
          return {
            tempFilePath: window.URL.createObjectURL(file),
            size: file.size
          };
        }),
        files: files
      };
      success(res);
      complete(res);
      inputElement.remove && inputElement.remove();
    }, false);
    var MouseEvents = document.createEvent('MouseEvents');
    MouseEvents.initEvent('click', true, true);
    inputElement.dispatchEvent(MouseEvents);
  } catch (e) {
    fail(e);
    complete(e);
  }
}, _constant.CONTAINER_NAME.WEB);
var _default = chooseMedia;
exports.default = _default;